/**
 *
 * TableButtonSkeleton
 *
 */

import React, { memo } from 'react';

import Skeleton from '..';

function TableButtonSkeleton(props) {
  return <Skeleton variant="rounded" width={50} height={24} {...props} />;
}

export default memo(TableButtonSkeleton);
